// extracted by mini-css-extract-plugin
export default {"about":"AboutTheseSettingsLink_about__LxBk1"};